import React, { memo, ReactNode} from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import usePlantLayoutEditorHook from './plant-layout-editor.hook';
import * as styled from './plant-layout-editor.styles';
import themes from './themes';
import LoadingComponent from '../../components/Loding-component/LoadingComponent';

import SimpleList from '@plasma/ui.display.simple-list';
import EditableTable from '../../components/edit-table/editable-table';
import Modal from '@plasma/ui.layout.modal';
import Input from '@plasma/ui.input.input';
import Select from '@plasma/ui.input.select';
import Button from '@plasma/ui.general.button';



export interface PlantLayoutEditorProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = PlantLayoutEditorProps & ThemeOverride;

function PlantLayoutEditor(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const {
    dataForColumns,
    finalColumns,
    hiddenColumns,
    stillHiddenColumns,
    showModal,
    ResetselectedIndex,
    uniqueConsumableOptions_list,
    selectedConsumable,
    dataForModal,
    uniqueConsumableCodes_list,
    selectedConsumableDesc,
    setselectedConsumable,
    handleAddConsumable,
    handleConsumableCodeChange,
    consumableSelectionDisabled,
    isLoadingData,
    selectionQtys,
    removeItemFromAddedList,
    selectedConsumableCodeRedressedQtyChange,
    handleModalOk,
    HandleModalCancel,
    handleSelectionFromTable,
    handleSave,
  } = usePlantLayoutEditorHook(props);


  //console.log("TABLE DATA",dataForColumns, finalColumns)

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.PlantLayoutEditor className={`plant-layout-editor ${className ?? ''}`.trim()} style={style}>

        <EditableTable
          tableData={dataForColumns || []}
          tableColumns={finalColumns || []}
          handleSave={handleSave}
          saveReturnType={'complete'}
          hiddenColumns={hiddenColumns}
          stillHiddenColumns={stillHiddenColumns}
          showActions_ext={true}
          allowSelection={true}
          onlyAddableFields={[]}
          mandatoryFields={[]}
          Table_Header='PRODUCTION LINE EDITOR'
          selectInputReturnType={'display'}
          ButtonsVisible={{Edit: true, Delete: true, InsertDown: true, InsertUp: true, MoveDown: true, MoveUp: true}}
          allowInsertInitialBlankRow={true}
          defaultValuesColumns={['areacode','zonecode']}
          handleSelection={handleSelectionFromTable}
          ColourColoumnName={'areacode'}
          SubGroupColumnName={'zonecode'}
          groupByColours={true}
          ColorOptions={
            {baseColor:'#FFFFFFFF',
            transparency: 0.5,
            thickBorders: true,
            mainGroupColumnName:'areacode',
            subgroupColumnName: 'zonecode',
            seed:999,
            useTheColorOptions: true,
          }}
          clearTheSelection={ResetselectedIndex}
          expandableColumns={['consumablecodeext2']}
          showLoadingOnSelection={isLoadingData}
          />


        <Modal
            title={
              <div style={{borderBottom:'1px solid lightgrey', display:'flex'}}>
                <div style={{padding:'5px', background:'#11ff1122', borderRadius:'5px'}}>{dataForModal.equipmentcode}</div>
                <div style={{padding:'5px'}}> Consumable Associations</div>
              </div>
            }
            width={'max-content'}
            okText="Save"
            cancelText="Cancel"
            visible={showModal}
            onCancel={() => HandleModalCancel()}
            onOk={() => handleModalOk(dataForModal)}
            confirmLoading={false}
            destroyOnClose={true}
            closable={false}
        >
        <div style={{ display: 'flex', flexDirection: 'row'}}>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
              <div style={{ margin: '5px'}}>
                <div style={{minWidth:'100px'}}>Consumable</div>
                  <Select
                      style={{ width: '300px', justifyContent:'flex-end' }}
                      placeholder='Consumable'
                      onChange={(value) => setselectedConsumable(value)}
                      disabled={consumableSelectionDisabled}
                      value={selectedConsumable || dataForModal.consumablecode}
                      dropdownStyle={{minWidth: '500px'}}
                    >
                      { uniqueConsumableOptions_list?.map((item, index)=> (
                      <Option key={index} value={item.display}>
                        {item.display}
                      </Option>
                      ))}
                    </Select>
                </div>

              <div style={{ margin: '5px'}}>
                <div style={{minWidth:'100px'}}>Code</div>
                <Select
                  style={{ width: '300px', justifyContent:'flex-end' }}
                  placeholder='Consumable Code ext'
                  onChange={(value) => handleConsumableCodeChange(value)}
                  disabled = {false}
                  value={selectedConsumableDesc}
                  dropdownStyle={{minWidth: '500px'}}
                >
                  { uniqueConsumableCodes_list?.map((item, index)=> {
                    return (
                  <Option key={index} value={item.display}>
                    {item.display}
                  </Option>)
                  }
                  )}
                </Select>
              </div>

              <div style={{ margin: '5px', display: 'flex'}}>
                <div style={{ margin: '5px'}}>
                  <div>Quantity Redressed</div>
                  <input
                    style={{ width: '150px', border:'1px solid lightgrey' }}
                    type={'number'}
                    placeholder={'Quantity Redressed'}
                    value={selectedConsumableDesc?.trim() === "" ? undefined : selectionQtys.quantityredressed}
                    onChange={(e) => selectedConsumableCodeRedressedQtyChange(e, 'Redressed')}
                    />
                </div>

                <div style={{ margin: '5px'}}>
                  <div>Quantity Installed</div>
                  <input
                    style={{ width: '150px', border:'1px solid lightgrey' }}
                    type={'number'}
                    disabled={dataForModal?.consumablecodeext?.length > 0 }
                    placeholder={'Quantity Installed'}
                    value={selectedConsumableDesc?.trim() === "" ? undefined : selectionQtys.quantityinstalled}
                    onChange={(e) => selectedConsumableCodeRedressedQtyChange(e, 'Installed')}
                    />
                </div>
              </div>

                <Button
                  style={{ width: '200px', margin: '5px' }}
                  onClick={handleAddConsumable}
                  title="Add Consumable Code"
                  type="secondary"
                  disabled={selectedConsumableDesc?.trim() === "" || dataForModal.consumablecodeext?.length > 0}
                  suffixIcon= {{name: 'add_circle_outline'}}
                />

            </div>
            <div
            style={{ maxHeight: '30vh',
            overflowY: 'auto'}}>
              <SimpleList
                dataSource={dataForModal.consumablecodeext}
                renderItem={(item) => (
                  <div style={
                            {marginLeft: '15px',
                            marginTop:'5px',
                            display: 'flex',
                            padding: '5px',
                            alignItems: 'center',


                        }}>

                    <div style={{ display: 'flex', alignItems: 'flex-start'}}>
                      <div style={{ width: 'max-content', padding:'2px', backgroundColor: '#AAFFAA', borderRadius: '5px', border: '1px solid #00FF99FF'}}>
                        {item}
                      </div>

                    </div>

                    <div style={{  width: '100%'}}>
                      <Button
                        key="btn1"
                        prefixIcon={{name: 'delete_outline'}}
                        type="tertiary"
                        size="small"
                        style={{ marginLeft: 'auto' }}
                        onClick={() => removeItemFromAddedList(item)}
                        />
                    </div>
                  </div>

                  )}
                itemLayout="horizontal"
                header={<span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                          { selectedConsumable || dataForModal.consumablecode}
                        </span>}
                bordered
              />

            </div>
          </div>
      </Modal>


      </styled.PlantLayoutEditor>
    </ThemeProvider>
  );
}

export default memo(PlantLayoutEditor) as unknown as typeof PlantLayoutEditor;
